/**
 * views/index.js
 */
export {default as HomeView} from './home/HomeView';
export {default as Error404} from './error404/Error404';
export {default as Success} from './success/Success';
export {default as MotdView} from './motd/MotdView';
export {default as BlogWrapper} from './blog/BlogWrapper';
export {default as ArticleWrapper} from './blog/ArticleWrapper';
export {default as FaqView} from './faq/FaqView';
